import { Tooltip } from '@byecode/ui'
import type { DataSourceAbstract } from '@lighthouse/core'
import type { SendMsgDingTalkRobotConfig, VariableTree2 } from '@lighthouse/shared'
import { getInputInnerTypeMatch, NodeFieldPreview } from '@lighthouse/shared'
import * as React from 'react'

import * as SC from './styles'

interface PersonConfigProps {
    userOption?: VariableTree2
    upstreamOptions: VariableTree2[]
    dataSourceList?: DataSourceAbstract[]
    value: SendMsgDingTalkRobotConfig
    onChange: (value: SendMsgDingTalkRobotConfig) => void
}

export const PersonConfig: React.FunctionComponent<PersonConfigProps> = ({
    userOption,
    upstreamOptions,
    dataSourceList,
    value,
    onChange
}) => {
    return (
        <>
            <SC.Item>
                <SC.Text>
                    提醒人员
                    <Tooltip
                        title={
                            <SC.TooltipContent>
                                可以输入 @all，提醒全部群成员，也
                                <br />
                                可以输入钉钉成员的手机号提醒多
                                <br />
                                人，并使用中/英文逗号隔开，例如
                                <br />
                                ：188****9089, 156****3321
                            </SC.TooltipContent>
                        }
                    >
                        <SC.Icon type="Question" size={16} color="var(--color-gray-400)" ml={7} />
                    </Tooltip>
                </SC.Text>
                <NodeFieldPreview
                    autoHeight
                    innerTypes={getInputInnerTypeMatch('TEXT')}
                    userOption={userOption}
                    upstreamOptions={upstreamOptions}
                    value={value.at?.atContent}
                    onBlur={atContent => onChange({ ...value, at: { ...value.at, atContent } })}
                    dataSourceList={dataSourceList}
                />
            </SC.Item>
        </>
    )
}
